import { useEffect, useLayoutEffect } from "react";
import { Outlet, createRootRoute, ScrollRestoration, useLocation } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { DocumentMeta } from "@/components/DocumentMeta";

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <div className="flex flex-1 items-center justify-center px-4">
        <div className="max-w-md text-center">
          <p className="text-7xl font-display font-bold text-primary">404</p>
          <h1 className="mt-4 font-display text-2xl font-semibold">Page not found</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            That page doesn't exist. Try browsing categories or cities instead.
          </p>
          <div className="mt-6 flex justify-center gap-3">
            <a href="/" className="rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground">Go home</a>
            <a href="/category/" className="rounded-full border border-border px-5 py-2.5 text-sm font-semibold">Browse categories</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootComponent,
  notFoundComponent: NotFoundComponent,
});

function RootComponent() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <ScrollRestoration />
      <DocumentMeta />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
